import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectedLocale } from '~/components/locale/utils';
import { selectCurrency } from '~/components/account/ducks/index';
import currencyFormatter from '~/libs/currency-formatter';

const useFormatCurrency = () => {
	const { locale } = useSelector(selectedLocale) as { locale: string };
	const userCurrency = useSelector(selectCurrency);

	const formatCurrency = useCallback(
		({
			value,
			currencyCode,
			hideDecimals = true
		}: {
			value?: number;
			currencyCode?: string;
			hideDecimals?: boolean;
		}) => {
			const currentCurrency = currencyCode || userCurrency;
			return (
				typeof value === 'number' && locale && currentCurrency
					? currencyFormatter.format(value, currentCurrency, locale, hideDecimals)
					: ''
			) as string;
		},
		[userCurrency, locale]
	);

	return formatCurrency;
};

export default useFormatCurrency;
